import { render, staticRenderFns } from "./CalendarListItem.vue?vue&type=template&id=a7253930&"
import script from "./CalendarListItem.vue?vue&type=script&lang=js&"
export * from "./CalendarListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7253930')) {
      api.createRecord('a7253930', component.options)
    } else {
      api.reload('a7253930', component.options)
    }
    module.hot.accept("./CalendarListItem.vue?vue&type=template&id=a7253930&", function () {
      api.rerender('a7253930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListItem.vue"
export default component.exports